import { client, params, extend } from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';

import {
  arrayOf as arrayOfType,
  number as numberType,
  shape as shapeType,
  string as stringType,
  bool as boolType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';

const Dates = shapeType({
  start: stringType(),
  end: stringType()
});

const Description = shapeType({
  shortDesc: stringType(),
  longDesc: stringType()
});

const Fulfillment = client(params({ storeId: stringType() }).shape({
  fulfillmentOptions: arrayOfType(shapeType({
    fulfillable: boolType(),
    type: stringType(),
    services: arrayOfType(shapeType({
      type: stringType(),
      locations: arrayOfType(shapeType({
        isAnchor: boolType(),
        locationId: stringType(),
        inventory: shapeType({
          isOutOfStock: boolType(),
          quantity: numberType()
        })
      }))
    }))
  }))
}));

const Identifiers = shapeType({
  brandName: stringType(),
  productType: stringType(),
});

const Media = shapeType({
  image: shapeType({
    url: stringType()
  }).client(),
  images: arrayOfType(shapeType({
    url: stringType(),
    sizes: arrayOfType(stringType()),
    type: stringType(),
    subType: stringType()
  }))
});

const ConditionalPromotions = shapeType({
  dates: Dates,
  description: Description,
  experienceTag: stringType(),
  subExperienceTag: stringType(),
  eligibilityCriteria: arrayOfType(shapeType({
    itemGroup: stringType(),
    minPurchaseAmount: numberType({ float: true }),
    minPurchaseQuantity: numberType({ float: true }),
    relatedSkusCount: numberType(),
    omsSkus: arrayOfType(stringType())
  })),
  reward: shapeType({
    tiers: arrayOfType(shapeType({
      minPurchaseAmount: numberType({ float: true }),
      minPurchaseQuantity: numberType({ float: true }),
      rewardPercent: numberType({ float: true }),
      rewardAmountPerOrder: numberType({ float: true }),
      rewardAmountPerItem: numberType({ float: true }),
      rewardFixedPrice: numberType({ float: true }),
      maxAllowedRewardAmount: numberType({ float: true }),
      maxPurchaseQuantity: numberType({ float: true })
    }))
  }),
  nvalues: arrayOfType(stringType()),
  brandRefinementId: stringType()
});

export const dataModel = extend({
  product: params({ itemId: stringType().isRequired() }).shape(extend({
    dataSource: stringType(),
    itemId: stringType(),
    pricing: params({ storeId: stringType().isRequired() }).shape({
      alternate: shapeType({
        bulk: shapeType({
          value: numberType({ float: true })
        })
      }),
      value: numberType({ float: true }),
      conditionalPromotions: arrayOfType(ConditionalPromotions),
      preferredPriceFlag: boolType(),
    }),
    fulfillment: Fulfillment,
    media: Media,
    identifiers: Identifiers,
  },
  ProductPod.dataModel.product,
  )),
});
